
import { dispatchShowSnack } from '@/store/dispatches'

import { Snack, SnackType } from '@/interfaces/snack'
import router from '../router'

export function showErrors (errors: any): void {
  if (errors) {
    errors.map((error: any) => {
      if (error.message) {
        dispatchShowSnack({
          msg: error.message,
          type: SnackType.Error
        })
        if (error.extensions.errorFields.statusCode === 401) {
          setTimeout(() => {
            router.replace({ name: 'SignIn' })
          }, 1000)
        }
      }
    })
  } else {
    dispatchShowSnack({
      msg: errors,
      type: SnackType.Error
    })
  }
}

export function showNotification (msg: Snack): void {
  dispatchShowSnack(msg)
}
